import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';

import { emailSequencesApi } from '../api/emailSequences';
import { vendorsApi } from '../api/vendors';

/**
 * MESA-4976: vendor email sequences are changed through `vendorsApi`, but the audit log is read
 * through `emailSequencesApi`, and RTK Query tag invalidation never crosses a slice boundary. Every
 * vendor sequence change writes an audit entry, so this refreshes the audit log after each one --
 * e.g. the collapsed audit section on the vendor sequence page right after a save. Lives outside
 * the slices for the same reason as matchingCacheInvalidation.
 */
export const emailSequenceAuditCacheInvalidation = createListenerMiddleware();

const vendorEmailSequenceMutations = [
  vendorsApi.endpoints.saveVendorEmailSequence,
  vendorsApi.endpoints.pauseVendorEmailSequence,
  vendorsApi.endpoints.resumeVendorEmailSequence,
  vendorsApi.endpoints.activateVendorEmailSequence,
  vendorsApi.endpoints.cloneVendorEmailSequence,
  vendorsApi.endpoints.createVendorEmailSequenceFromTemplate,
  vendorsApi.endpoints.sendVendorEmailSequenceStepNow,
  vendorsApi.endpoints.bulkVendorEmailSequenceAction,
] as const;

emailSequenceAuditCacheInvalidation.startListening({
  matcher: isAnyOf(...vendorEmailSequenceMutations.map((endpoint) => endpoint.matchFulfilled)),
  effect: async (_action, listenerApi) => {
    listenerApi.dispatch(emailSequencesApi.util.invalidateTags(['EmailSequenceAuditLog']));
  },
});

export default emailSequenceAuditCacheInvalidation;
